import "@babel/polyfill";
import "whatwg-fetch";

import "bootstrap";

import "./main.scss";

export {
    default,
} from "./main.js";



// WEBPACK FOOTER //
// ./src/index.js